// Master COGS file — supplier cost per vial
// Source: PeptidePriceList.xlsx (supplier price / 10 vials)
// Used by store (calc profit on order) + admin (display real margins)

export const COST_BASIS = {
  // Retatrutide
  'RR-RT-10mg': 9.00, 'RR-RT-30mg': 20.00, 'RR-RT-60mg': 45.00,
  // Semaglutide
  'RR-SM-10mg': 5.50, 'RR-SM-20mg': 8.00, 'RR-SM-30mg': 11.00,
  // Tirzepatide
  'RR-TR-10mg': 5.00, 'RR-TR-30mg': 10.50, 'RR-TR-60mg': 22.00,
  // BPC-157
  'RR-BC-5mg': 4.00, 'RR-BC-10mg': 7.00,
  // TB-500
  'RR-TB-5mg': 9.50, 'RR-TB-10mg': 16.00,
  // BPC + TB Stack
  'RR-BB-5mg+5mg': 12.00, 'RR-BB-10mg+10mg': 22.00,
  // Ipamorelin
  'RR-IP-5mg': 4.00, 'RR-IP-10mg': 7.00,
  // CJC-1295
  'RR-CJ-2mg': 4.00, 'RR-CJ-5mg': 8.50,
  // Sermorelin
  'RR-SR-5mg': 7.50, 'RR-SR-10mg': 14.00,
  // Semax
  'RR-XA-5mg': 5.50, 'RR-XA-10mg': 9.50,
  // Selank
  'RR-SK-5mg': 5.50, 'RR-SK-10mg': 9.50,
  // Epithalon
  'RR-ET-10mg': 4.00, 'RR-ET-50mg': 15.00,
  // NAD+
  'RR-NJ-100mg': 4.00, 'RR-NJ-500mg': 8.00, 'RR-NJ-1000mg': 14.00,
  // BAC Water
  'RR-BAC-3mL': 0.80, 'RR-BAC-10mL': 1.00,
  // KLOW Stack
  'RR-KW-80mg': 19.00,
  // MT-1, MT-2
  'RR-MT1-10mg': 5.50, 'RR-MT2-10mg': 5.50,
  // PT-141
  'RR-PT-10mg': 7.00,
  // HGH
  'RR-HG-10iu': 5.00, 'RR-HG-15iu': 9.10, 'RR-HG-24iu': 16.00, 'RR-HG-36iu': 19.50,
  // GHK-Cu
  'RR-GH-50mg': 3.50, 'RR-GH-100mg': 6.00,
  // Tesamorelin
  'RR-TS-5mg': 11.00, 'RR-TS-10mg': 5.50, 'RR-TS-20mg': 20.00,
  // MOTS-c
  'RR-MC-10mg': 6.50, 'RR-MC-20mg': 12.50, 'RR-MC-30mg': 18.50, 'RR-MC-40mg': 25.50,
};

// Lookup cost per vial by product code + variant mg
export function getCost(code, mg) {
  const key = `${code}-${mg}`;
  return COST_BASIS[key] || 0;
}

// Calculate total COGS for a cart array
export function calcCogs(cart) {
  return cart.reduce((sum, item) => {
    const costPerVial = getCost(item.code, item.mg);
    return sum + (costPerVial * (item.qty || 1) * (item.mult || 1));
  }, 0);
}

// Calculate profit on a single item
export function calcItemProfit(item) {
  const cost = getCost(item.code, item.mg) * (item.qty || 1) * (item.mult || 1);
  const revenue = (item.unitPrice || item.price || 0) * (item.qty || 1);
  return revenue - cost;
}
